import { api } from '@api/axios';

export interface GroupSettingsResponse {
  id: string;
  name: string;
  description: string | null;
  host: string;
  status: number;
  type: number;
  settings: {
    colors: {
      denary: string;
      nonary: string;
      senary: string;
      primary: string;
      quinary: string;
      octonary: string;
      tertiary: string;
      secondary: string;
      septenary: string;
      quaternary: string;
    };
    images: { logo: string, welcome: string, emailHeader: string, emailFooter: string, favIcon: string };
    emails: { primary: string; secondary: string | null };
    phones: { primary: string; secondary: string | null };
    texts: {
      welcomeText: string;
      welcomeTitle: string;
    }
  };
  plans?: {planId: number}[]
}

export class GroupsService {
  static async getByHash(groupHash: string): Promise<GroupSettingsResponse> {
    const { data } = await api.get<GroupSettingsResponse>(`/groups/${groupHash}`);
    return data;
  }
}


